<script setup>
import { computed } from 'vue';
import { useKeyboardEvents } from 'dashboard/composables/useKeyboardEvents';
import wootConstants from 'dashboard/constants/globals';

const props = defineProps({
  items: {
    type: Array,
    default: () => [],
  },
  activeTab: {
    type: String,
    default: wootConstants.ASSIGNEE_TYPE.ME,
  },
});

const emit = defineEmits(['chatTabChange']);

const activeTabIndex = computed(() => {
  return props.items.findIndex(item => item.key === props.activeTab);
});

const onTabChange = selectedTabIndex => {
  if (selectedTabIndex >= 0 && selectedTabIndex < props.items.length) {
    const selectedItem = props.items[selectedTabIndex];
    if (selectedItem.key !== props.activeTab) {
      emit('chatTabChange', selectedItem.key);
    }
  }
};

const keyboardEvents = {
  'Alt+KeyN': {
    action: () => {
      if (props.activeTab === wootConstants.ASSIGNEE_TYPE.ALL) {
        onTabChange(0);
      } else {
        const nextIndex = (activeTabIndex.value + 1) % props.items.length;
        onTabChange(nextIndex);
      }
    },
  },
};

useKeyboardEvents(keyboardEvents);
</script>

<template>
  <!-- v6.4.12: Flex-wrap pill tabs (estilo WhatsApp) — substitui scroll horizontal com setas -->
  <div class="flex flex-wrap gap-1.5 px-3 py-2">
    <button
      v-for="(item, index) in items"
      :key="item.key"
      class="chat-type-pill"
      :class="{ 'chat-type-pill--active': item.key === activeTab }"
      @click="onTabChange(index)"
    >
      <span class="whitespace-nowrap">{{ item.name }}</span>
      <span
        v-if="item.count != null"
        class="chat-type-pill__badge"
        :class="{ 'chat-type-pill__badge--active': item.key === activeTab }"
      >
        {{ item.count }}
      </span>
    </button>
  </div>
</template>

<style scoped>
.chat-type-pill {
  @apply inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-normal
    border border-n-strong/20 dark:border-n-weak bg-n-alpha-black2 dark:bg-n-solid-3 text-n-slate-11
    cursor-pointer select-none
    transition-all duration-150 ease-in-out;
}

.chat-type-pill:hover {
  @apply bg-n-alpha-black2 dark:bg-n-solid-3 text-n-slate-12;
}

.chat-type-pill--active {
  @apply border-n-brand bg-n-brand/10 dark:bg-n-brand/20 text-n-blue-text;
}

.chat-type-pill--active:hover {
  @apply bg-n-brand/15 dark:bg-n-brand/25;
}

.chat-type-pill__badge {
  @apply inline-flex items-center justify-center min-w-[18px] h-[18px]
    px-1 rounded-md text-xxs font-semibold
    bg-n-alpha-black2 dark:bg-n-solid-3 text-n-slate-11;
}

.chat-type-pill__badge--active {
  @apply bg-n-brand/20 dark:bg-n-brand/30 text-n-blue-text;
}
</style>
